import React, { useContext, useEffect, useState } from 'react';

import { AppContext } from '../../app';
import { Button, Form } from 'antd';
import ProductSegmentPredicateComponent from '@Modules/insight/productSegment/component/ProductSegmentPredicateComponent';

const predicateDefault = {
  attribute: null,
  type: 'CHECK_USER_ATTRIBUTE',
  negate: false,
};

const CondCheckUserAttr = (props) => {
  const [form] = Form.useForm();
  const { journey, syncCache } = useContext(AppContext);
  const {
    attributes,
    events,
    fetchRecommendDeviceAttributes,
    fetchRecommendEventAttributes,
    fetchRecommendUserAttributes,
    recommendDeviceAttributes,
    recommendEventAttributes,
    recommendUserAttributes,
  } = props.data;
  const [predicate, setPredicate] = useState(predicateDefault);

  useEffect(() => {
    const currentStep = journey.steps.find(
      (step) => step.id + '' === props.node.id + ''
    );
    if (currentStep) {
      setPredicate(
        Object.assign({}, predicateDefault, currentStep?.ui?.predicate)
      );
    }
  }, []);

  const onFinish = () => {
    const currentStep = journey.steps.find(
      (step) => step.id + '' === props.node.id + ''
    );
    const ui = Object.assign({}, currentStep?.ui, { predicate });
    // return;
    const currentStepUpdated = Object.assign({}, currentStep, predicate, {
      ui,
    });
    delete currentStepUpdated.ui?.error;
    syncCache('update-step', currentStepUpdated, true);
    // openSnackBar("success", {
    //   message: "Successfully updated",
    // });
    props.closeModal();
  };

  const handleChangePredicate = (changedPredicate) => {
    setPredicate(changedPredicate);
  };

  return (
    <>
      <Form form={form} onFinish={onFinish} className="modal_wrap">
        <div className={'modal-body'}>
          <ProductSegmentPredicateComponent
            journey={true}
            readOnly={props.readOnly}
            type="CHECK_USER_ATTRIBUTE"
            predicate={predicate}
            attributes={attributes}
            events={events}
            isInSegment={false}
            handleChangePredicate={(changedPredicate) =>
              handleChangePredicate(changedPredicate)
            }
            clearSegmentError={() => {
              //TODO Must Handle
            }}
            fetchRecommendEventAttributes={fetchRecommendEventAttributes}
            recommendEventAttributes={recommendEventAttributes}
            fetchRecommendDeviceAttributes={fetchRecommendDeviceAttributes}
            recommendDeviceAttributes={recommendDeviceAttributes}
            fetchRecommendUserAttributes={fetchRecommendUserAttributes}
            recommendUserAttributes={recommendUserAttributes}
          />
        </div>
        <div className={'modal-footer'}>
          <Form.Item>
            <Button
              shape="round"
              type="primary"
              htmlType="submit"
              disabled={props.readOnly}
            >
              Save State
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};
export default CondCheckUserAttr;
